import './notification.scss';

// var addButtonTrigger = function addButtonTrigger(el) {
//
//   el.addEventListener('click', function () {
//     var popupEl = document.querySelector('.' + el.dataset.for);
//     popupEl.classList.toggle('popup_cp--visible');
//   });
//
// };
//
//
// Array.from(document.querySelectorAll('button[data-for]')).forEach(addButtonTrigger);

$(function () {
  $('[data-role=popup_cp]').jqueryPopup();
});

$.fn.jqueryPopup = function (method) {
  var methods = {
    init: function () {
      var $list = $(this);

      $list.each(function(){
        var $elem = $(this);

        $elem.on('click', '[data-role=close-popup]', methods.closeSelf);
        $elem.on('click', '.popup_cp__background', methods.closeSelf);
      });

      $('body').on('click', '[data-role=show-popup]', methods.showPopup);
    },
    show: function() {
      var $target = $(this);

      if ( $target.length ) {
        $target.addClass('popup_cp--visible');

        methods['fireEvent'].call($target, 'shown.cp.popup');
      }
    },
    close: function() {
      var $target = $(this);

      if ( $target.length ) {
        $target.removeClass('popup_cp--visible');

        methods['fireEvent'].call($target, 'hidden.cp.popup');
      }
    },
    closeSelf: function() {
      var $target = $(this).closest('[data-role=popup_cp]');

      methods['close'].call($target);
    },
    showPopup: function() {
      var $cur = $(this),
        id = $cur.data('target'),
        selector = `[data-id=${id}]`,
        $target = $(selector);

      methods['show'].call($target);
    },
    fireEvent: function(eventName) {
      var event,
        elem = $(this)[0];

      if ('createEvent' in document) {
        event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, true, true);
        elem.dispatchEvent(event);
      } else {
        event = document.createEventObject();
        event.eventType = eventName;
        elem.fireEvent('on'+event.eventType, event);
      }

      $(elem).trigger(eventName);
    },
  };

  // console.log('actions');
  if (methods[method]) {
    // console.log("method %s isset", method);
    return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
  } else {
    // console.log('run default method');
    return methods.init.apply(this, arguments);
  }
};



// WEBPACK FOOTER //
// ./resources/views/partials/index/popups/notification/notification.js